import { CdnImageUtils } from 'javascripts/shared/utils/cdn_image_utils';

// Multiplying x2 for to avoid blurriness on double pixel density screens.
const SIZE_MAPPINGS = {
  large: 330 * 2,
  medium: 210 * 2,
};
const DEFAULT_SIZE = SIZE_MAPPINGS.large;

export const CoverImageUtils = {
  fetchScaledImage(imageUrl, size) {
    if (_.includes(imageUrl, '/assets/default-cover-image')) {
      return imageUrl;
    }

    const optimizations = [];
    optimizations.push(['f_auto', 'q_auto:low']);

    const dimension = _.get(SIZE_MAPPINGS, size, DEFAULT_SIZE);
    optimizations.push([`w_${dimension}`, `h_${dimension}`]);

    const slug = CdnImageUtils.getCloudinarySlug(imageUrl);
    if (!_.isEmpty(slug)) {
      return CdnImageUtils.getOptimizedImage(slug, optimizations, false);
    }

    if (_.includes(imageUrl, 'img.chirpbooks.com/image')) {
      return imageUrl;
    }

    return CdnImageUtils.fetchOptimizedImage(imageUrl, optimizations, false);
  },
};
